<template>
  <a-checkbox-group
    v-model="modelList[name]"
    @change="(e)=>findEvent({e})"
    v-bind="$attrs.item"
  />
</template>

<script>
import formMixin from "@/minxin/form.mixin.js";
import { Checkbox } from "ant-design-vue";
import Vue from 'vue'
Vue.use(Checkbox)
export default {
  mixins: [formMixin],
  props: {
    name: {},
    modelList: {},
    funcList: {},
  },
};
</script>
